import Vue from "vue";
import VueFeather from "vue-feather";
import VueLayers from "vuelayers";
import App from "./views/main/index.vue";
import router from "./router";
import store from "./store";
import Video from "video.js";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "./plugins/element.js";
import "./assets/theme/index.css";
import "swiper/css/swiper.css";
import "@coddicat/vue-pinch-scroll-zoom/style.css";
import "vuelayers/dist/vuelayers.css";
import "./assets/scss/core.scss";
import "video.js/dist/video-js.css";

Vue.config.productionTip = false;
Vue.use(VueFeather);
Vue.use(VueLayers);
Vue.use(VueAwesomeSwiper);
Vue.prototype.$video = Video;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
